// App.tsx
import React, { useState, useEffect } from 'react';
import QuizApp from './QuizApp';
import QuizConfig from './QuizConfig'
import { QuestionData, QuizConfigs, QuizSet, QuizSetting } from './types';
import d_q_set_1 from "./data/AWS_Mock_Test_Paper_Solution_Architect.json";
import d_q_set_2 from "./data/AWS-Solution-Architect-Associate-full_formatted_text.json";

const App: React.FC = () => {
  // const questionSet: QuestionData[][] = [d_q_set_1, d_q_set_2]
  //const mockQuestions: QuestionData[] = d_q_set_2;
  const quizSet_1: QuizSet = {
    qSetNo: 1,
    qSetQuestions: d_q_set_1,
    qSetTitle: "AWS Mock Test Paper Solution Architect"
  }
  const quizSet_2: QuizSet =
  {
    qSetNo: 2,
    qSetQuestions: d_q_set_2,
    qSetTitle: "AWS Solution Architect Associate full"
  }
  const qConfig: QuizConfigs = {
    quizSets: [quizSet_1, quizSet_2],
    noOfQuestionOnSet: -1
  }
  // State to hold the selected quiz configuration
  const [quizState, setQuizState] = useState({
    isConfigured: false,
    selectedSetNo: 1,
    numQuestions: 10,
    isQuestionSelectionRandom: true,
    startingQuestionIndex: 1
  });

  // State for the questions to render
  const [questionsToRender, setQuestionsToRender] = React.useState<QuestionData[]>([]);
  const [quizTitle, setQuizTitle] = React.useState<string>('');

  useEffect(() => {
    if (quizState.isConfigured) {
      const selectedQuizSet = qConfig.quizSets[quizState.selectedSetNo - 1];
      const questions = selectedQuizSet.qSetQuestions
      setQuizTitle(selectedQuizSet.qSetTitle);
      if (selectedQuizSet) {
        if (!quizState.isQuestionSelectionRandom) {
          setQuestionsToRender(questions.slice(
            quizState.startingQuestionIndex - 1,
            quizState.startingQuestionIndex + quizState.numQuestions - 1
          ));
        } else {
          let q: QuestionData[] = questions.slice(1, 0)
          //q.pop();
          const qNoSet = new Set();
          do {
            //for (let i: number = 0; i < quizState.numQuestions; i++) {
            qNoSet.add(getRandomQno(0, questions.length - 1));
            // --quizState.numQuestions;
            console.log(qNoSet);
          } while (qNoSet.size < quizState.numQuestions)
          qNoSet.forEach((value: any) => { q.push(questions[value]) });
          setQuestionsToRender(q);
        }
      }
    }
  }, [quizState.isConfigured]);

  function getRandomQno(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const handleSubmitFromQuizConfig = (data: QuizSetting) => {
    // The data passed from QuizConfig should be correct
    setQuizState({
      isConfigured: data?.isQuestionSetSelected || true,
      selectedSetNo: data.selectedQuestionSetNo,
      numQuestions: data.noOfQuestionsToAnswer,
      isQuestionSelectionRandom: data.isQuestionSelectionRandom,
      startingQuestionIndex: data.startingQuestionIndex
    });
  };


  return (
    <div className="App" >
      {quizState.isConfigured ? (
        // Only render QuizApp if questionsToRender has been populated
        questionsToRender.length > 0 && <QuizApp qTitle={quizTitle} questions={questionsToRender} />
      ) : (
        <QuizConfig qConfig={qConfig} onAction={handleSubmitFromQuizConfig} />
      )}
    </div>
  );
};

export default App;